<script setup>
    // Vue
    import { ref, defineEmits, defineExpose, inject } from 'vue';

    // Store
    import { useAgreementListStore } from '@/stores/modal/agreementListStore';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    // 親画面から取得したAPIのドメイン部を管理する。
    const API_URL = ref('');

    // ----------------------------
    // ユーザー同意済規定一覧取得のStore
    // ----------------------------
    const agreementListStore = useAgreementListStore();

    /**
     * ユーザー同意済規定一覧取得APIをコールする。
     * @param API_URL
     * @param requestBody
     * @returns なし
     */
    async function getAgreementList(API_URL, requestBody) {
        // ユーザー同意済規定一覧取得APIをコールする。
        const response = await agreementListStore.getAgreementListAction(API_URL, requestBody);
        if (!response.success) {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
        }
    }

    // ----------------------------
    // 親側実装必須処理
    // ----------------------------
    const emit = defineEmits(['agreementListModal:close', 'agreementListModal:open']);
    function open(regulationPk, regulationHistPk) {
        // Storeを初期化する。
        agreementListStore.reset();

        // 親画面のモーダル非表示処理を呼び出す
        emit('agreementListModal:open', regulationPk, regulationHistPk);
    }
    function close() {
        // Storeを初期化する。
        agreementListStore.reset();

        // 親画面のモーダル非表示処理を呼び出す
        emit('agreementListModal:close');
    }

    /**
     * 親画面から規定同意一覧モーダルを開くイベントが実行された場合の処理。
     * @param {String} trg HTMLファイルタグが生成されている座標を取得する。
     * @returns なし
     */
    async function openModal(trg, lang) {
        // Storeを初期化する。
        agreementListStore.reset();

        // APIのURLを継承する。
        API_URL.value = trg;

        // ユーザー同意済規定一覧取得APIのリクエストボディを生成する。
        const requestBody = {
            Lang: lang,
        };

        // ユーザー同意済規定一覧取得APIをコールする。
        await getAgreementList(API_URL.value, requestBody);

        // モーダルのHTML要素を取得する。
        const elm1 = document.querySelector('#modalAgreedTermsList .modalContents');

        // モーダルの縦スクロールを先頭に戻す。
        elm1.scrollTop = 0;
    }
    defineExpose({
        openModal,
    });
</script>

<style></style>

<template>
    <article id="modalAgreedTermsList" class="modal" :style="{ display: 'block' }">
        <h3>{{ $t('agreementList.parts.modalTitle1') }}</h3>
        <section class="modalContents">
            <section class="innerTable">
                <table class="table">
                    <thead>
                        <tr>
                            <th>
                                <span>{{ $t('agreementList.parts.tableHeader1') }}</span>
                            </th>
                            <th>
                                <span>{{ $t('agreementList.parts.tableHeader3') }}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="termsDetail" v-for="agreeStipulate in agreementListStore.agreementList" :key="agreeStipulate.RegulationNm" @click="open(agreeStipulate.RegulationPk)">
                            <td>
                                <span>{{ agreeStipulate.RegulationNm }}</span>
                            </td>
                            <td>
                                <span>{{ agreeStipulate.AgreementDt }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </section>
        <section class="modalFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" @click="close">
                        {{ $t('common.parts.backPage') }}
                    </button>
                </li>
            </ul>
        </section>
    </article>
</template>
<style scoped>
    /* この画面だけのスタイルを上書きする */
    /* #overlay .modal .modalContents > .form > dl > dt {
        width: 224px;
    }
    #overlay .modal .modalContents > .form > dl > dd {
        width: calc(100% - 224px);
    }
    @media screen and (max-width: 1280px) {
        #overlay .modal .modalContents > .form > dl > dt {
            width: 100%;
            margin-bottom: 2px;
        }
        #overlay .modal .modalContents > .form > dl > dd {
            width: 100%;
        }
    } */
    /* #overlay .modal .modalContents > .form > dl > dt > ul.formLabel > li {
        width: auto;
    } */
    #overlay .modal .modalContents > .innerTable table.table thead tr th:nth-child(1),
    #overlay .modal .modalContents > .innerTable table.table tbody tr td:nth-child(1) {
        width: 450px;
        padding-left: 10px;
    }
    /* #overlay .modal .modalContents > .innerTable table.table thead tr th:nth-child(2),
    #overlay .modal .modalContents > .innerTable table.table tbody tr td:nth-child(2) {
        width: 150px;
    } */
    @media screen and (max-width: 1280px) {
        #overlay .modal .modalContents > .innerTable table.table thead tr {
            display: flex;
        }
        #overlay .modal .modalContents > .innerTable table.table tbody tr {
            display: flex;
            padding-top: 12px;
        }
        #overlay .modal .modalContents > .innerTable table.table thead tr th:nth-child(1),
        #overlay .modal .modalContents > .innerTable table.table tbody tr td:nth-child(1) {
            width: 100%;
            min-width: calc(100% - 180px);
            max-width: calc(100% - 180px);
        }
        #overlay .modal .modalContents > .innerTable table.table thead tr th,
        #overlay .modal .modalContents > .innerTable table.table tbody tr td {
            height: auto;
            min-height: 30px;
            padding-right: 18px;
        }
    }
</style>
